import { exitGame } from '@/utilities/helpers/exitGame';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PluginErrorButtonActions = ({
  translation,
}: {
  translation: 'PLCNotInstalled';
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="modal__buttons">
        <>
          <a
            onClick={() => exitGame()}
            className="btn btn--transparent"
            role="button"
            data-testid="geolocation-dismiss-button"
          >
            {t(`${translation}.dismiss`)}
          </a>
          <Link
            to={'/plc-plugin'}
            className="btn btn__link btn-main"
            role="button"
          >
            {t(`${translation}.downloadPlugin`)}
          </Link>
        </>
      </div>
    </>
  );
};

export default PluginErrorButtonActions;
